import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function redirecter (redirectLocation) {
  location.href = `/signin?dest=${encodeURIComponent(redirectLocation)}`;
}

export function requireAuth (Component) {
  class AuthContainer extends React.Component {
    UNSAFE_componentWillMount () {
      this.verifyAuth(this.props.accessToken);
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
      this.verifyAuth(nextProps.accessToken);
    }

    verifyAuth (accessToken) {
      if (!accessToken) {
        const { location } = this.props;
        const redirectLocation = `${location.pathname}${location.search}`;

        redirecter(redirectLocation);
      }
    }

    render () {
      return (
        <div>
          <Component {...this.props} />
        </div>
      );
    }
  }

  AuthContainer.propTypes = {
    accessToken: PropTypes.string,
    location: PropTypes.object.isRequired
  };

  const mapStateToProps = (state) => ({
    accessToken: state.auth.accessToken
  });

  return connect(mapStateToProps)(AuthContainer);
}
